const storageKey = 'footer-newsletter-submission';

// 与活动订阅一致：记录提交表单，交由 Shopify 处理提交。
document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-footer-newsletter] form');
  if (!form?.id) return;
  try { sessionStorage.setItem(storageKey, form.id); } catch (_) {}
});

function clearSubmittedFormState(formId) {
  document.querySelectorAll('[data-footer-newsletter-success]').forEach((marker) => marker.remove());
  try { sessionStorage.removeItem(storageKey); } catch (_) {}
  if (location.hash.slice(1) !== formId || !history.replaceState) return;
  history.replaceState(history.state, document.title, `${location.pathname}${location.search}`);
}

function showNewsletterSuccess(scope = document) {
  let id = '';
  const hash = location.hash.slice(1);
  if (hash.startsWith('FooterNewsletter-')) id = decodeURIComponent(hash);
  if (!id) {
    try { id = sessionStorage.getItem(storageKey) || ''; } catch (_) {}
  }
  if (!id) id = scope.querySelector('[data-footer-newsletter-success]')?.closest('form')?.id || '';
  if (!id) return;
  const form = document.getElementById(id);
  if (!form?.closest('[data-footer-newsletter]')) return;
  if (!form.querySelector('[data-footer-newsletter-success]')) {
    const error = form.querySelector('.form-notification.error');
    if (!error) return;
    error.focus({ preventScroll: true });
    clearSubmittedFormState(id);
    return;
  }
  const modal = document.getElementById(`${id}-modal`);
  if (!modal || typeof modal.show !== 'function') return;
  modal.show(form.querySelector('[type="submit"]'));
  requestAnimationFrame(() => modal.querySelector('[role="dialog"]')?.focus());
  clearSubmittedFormState(id);
}

document.addEventListener('shopify:section:load', (event) => showNewsletterSuccess(event.target));
window.addEventListener('pageshow', () => showNewsletterSuccess());
showNewsletterSuccess();

// 弹窗会移动到 body，使用事件委托保持优惠码复制可用。
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-footer-copy-code]');
  if (!button || button.disabled) return;
  const status = button.closest('.footer-newsletter-modal__content')?.querySelector('[data-footer-copy-status]');
  button.disabled = true;
  try {
    await navigator.clipboard.writeText(button.dataset.footerCopyCode);
    button.textContent = 'Copied';
    if (status) status.textContent = 'Discount code copied.';
    clearTimeout(button.copyResetTimer);
    button.copyResetTimer = setTimeout(() => { button.textContent = 'Copy'; }, 2000);
  } catch (_) {
    if (status) status.textContent = 'Unable to copy. Please copy the code manually.';
  } finally {
    button.disabled = false;
  }
});
